/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { setFieldValueAtPath } from "data/store/reducers/model";
import { useDynamicFieldPosition } from "cms/fields/dynamic-field/context/use-dynamic-field-position";

const useUpdateFieldSetting = () => {
    
    const dispatch = useDispatch();

    const fieldPosition = useDynamicFieldPosition();

    const updateFieldSetting = useCallback((setting, value) => {
        const path = [
            "fields", fieldPosition,
            "settings", setting
        ];
        const payload = { path, value };
        dispatch(setFieldValueAtPath(payload));
        
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fieldPosition]);

    return { updateFieldSetting };
    
};

export { useUpdateFieldSetting };
